
import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center py-20">
        <div className="container px-4">
          <div className="max-w-lg mx-auto text-center">
            <div className="text-blue-600 font-bold text-9xl mb-4">404</div>
            <h1 className="heading-lg mb-6">Page Not Found</h1>
            <p className="text-gray-600 text-lg mb-8">
              We couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
            </p>
            <Link 
              to="/" 
              className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium transition-colors"
            >
              <ArrowLeft className="mr-2 w-4 h-4" />
              <span>Return to Home</span>
            </Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
